export default "__VITE_PUBLIC_ASSET__0e8b8a0d__"